import { Feature, MultiPolygon, Polygon } from 'geojson'
import { useContext } from 'react'
import GoogleCluster from '../googleMap/neoCluster'
import MapboxCluster from '../mapbox/neoCluster'
import { MapContext } from './mapContext'
import { Layer } from '~/packages/general/variable/spaceTime.types'
import { NeoClusterPosition } from './mapPosition'
import { ActionCall } from '~/prix/react/hooks/concurrentActions'

export interface ClusterProps {
  positions: NeoClusterPosition[]
  layers: Layer[]
  layerIndex: number
  layerRequest: ActionCall
  delimitation?: Polygon | MultiPolygon
  onClickCluster?: (
    feature: Feature<
      Polygon | MultiPolygon,
      {
        h3: string
        value: number
        preservedAreaPercentage: number
      }
    >,
  ) => void
  onChangeLegend?: (index: number, range: { min: number; max: number }) => void
}

export default function NeoCluster(props: ClusterProps) {
  const mapContext = useContext(MapContext)
  if (!mapContext) {
    throw new Error('Cluster must be used within a map')
  }

  const { mapProvider } = mapContext

  let layerJSXElement: JSX.Element
  if (mapProvider === 'google') {
    layerJSXElement = <GoogleCluster {...props} />
  } else if (mapProvider === 'mapbox') {
    layerJSXElement = <MapboxCluster {...props} />
  } else {
    throw new Error(`Unsupported map provider: ${mapProvider}`)
  }

  return layerJSXElement
}
